module.exports = __webpack_public_path__ + "img/c-en-19.7dd28c78.png";